import React from "react";
import ColorInit from "../../helper/ColorInit";
import ScrollToTop from "react-scroll-to-top";
import Preloader from "../../helper/Preloader";
import HeaderGuest from "../../components/layout/HeaderGuest";
import FooterOne from "../../components/layout/FooterOne";
import BottomFooter from "../../components/layout/BottomFooter";


import TopImageHeader from "../../components/seller-registration/adminregistration/TopImageHeader";
import Breadcrumb from "../../components/seller-registration/adminregistration/Breadcrumb";
import SellerAdminRegistrationProgress from "../../components/seller-registration/adminregistration/Progress";
import SellerShopInformationPersonal from "../../components/seller-registration/adminregistration/PersonalShopInformationForm";


const PersonalSellerShopInformation = () => {
  return (
    <>
      {/* ColorInit */}
      <ColorInit color={false} />

      {/* ScrollToTop */}
      <ScrollToTop smooth color='#990A02' />

      {/* Preloader */}
      <Preloader />

    <HeaderGuest />
      
    <TopImageHeader />

    <Breadcrumb title={"Shop Information"} link={"/admin/register-seller-type"} />

    <SellerAdminRegistrationProgress progressStatus={"thirdfourth"} />

    <SellerShopInformationPersonal />


      {/* FooterTwo */}
      <FooterOne />

      {/* BottomFooter */}
      <BottomFooter />
    </>
  );
};

export default PersonalSellerShopInformation;